__turbopack_context__.v({
  "controls": "ParagraphGallerySlider-module__SIl5SW__controls",
  "controlsRow": "ParagraphGallerySlider-module__SIl5SW__controlsRow",
  "counter": "ParagraphGallerySlider-module__SIl5SW__counter",
  "empty": "ParagraphGallerySlider-module__SIl5SW__empty",
  "eyebrow": "ParagraphGallerySlider-module__SIl5SW__eyebrow" + " " + __turbopack_context__.i("[project]/components/cms/Paragraphs/layouts/sectionHeader.module.css [app-client] (css module)")["eyebrow"],
  "header": "ParagraphGallerySlider-module__SIl5SW__header",
  "lead": "ParagraphGallerySlider-module__SIl5SW__lead" + " " + __turbopack_context__.i("[project]/components/cms/Paragraphs/layouts/sectionHeader.module.css [app-client] (css module)")["lead"],
  "navBtn": "ParagraphGallerySlider-module__SIl5SW__navBtn",
  "navBtnNext": "ParagraphGallerySlider-module__SIl5SW__navBtnNext",
  "navBtnPrev": "ParagraphGallerySlider-module__SIl5SW__navBtnPrev",
  "slide": "ParagraphGallerySlider-module__SIl5SW__slide",
  "slideBtn": "ParagraphGallerySlider-module__SIl5SW__slideBtn",
  "slideCaption": "ParagraphGallerySlider-module__SIl5SW__slideCaption",
  "slideImg": "ParagraphGallerySlider-module__SIl5SW__slideImg",
  "slideImgWrap": "ParagraphGallerySlider-module__SIl5SW__slideImgWrap",
  "sliderWrap": "ParagraphGallerySlider-module__SIl5SW__sliderWrap",
  "swiper": "ParagraphGallerySlider-module__SIl5SW__swiper",
  "title": "ParagraphGallerySlider-module__SIl5SW__title" + " " + __turbopack_context__.i("[project]/components/cms/Paragraphs/layouts/sectionHeader.module.css [app-client] (css module)")["title"],
});
